export const generativeAiAppGroupIdBrandGuidelinesTestGeneration =
  "/:app_group_id/generative_ai/brand_guidelines_test_generation";
